/* Nana, l'assistante GRENADINE, en fenetre plein ecran facon cuure.com.
   Reprend a l'identique les questions et la logique du diagnostic en ligne
   (/pages/votre-diagnostic). Ouverture : window.GrenadineNana.open({ firstMessage, prenom }). */
(function () {
  if (window.GrenadineNana) return;

  function esc(t) {
    return String(t).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function buildModal() {
    var m = document.createElement("div");
    m.className = "nana-modal";
    m.setAttribute("role", "dialog");
    m.setAttribute("aria-modal", "true");
    m.innerHTML =
      '<header class="nana-head">' +
        '<span class="nana-avatar" aria-hidden="true"><img src="https://cdn.shopify.com/s/files/1/0729/3983/1631/files/coeur_grenadine_rose.png?v=1745434173&width=120" alt=""></span>' +
        '<div class="nana-head-text"><p class="nana-head-title">Trouvez votre soin</p>' +
        '<p class="nana-head-sub">Nana, notre mamie des cheveux de GRENADINE, vous aide à trouver le bon chemin pour vos cheveux 🩷</p></div>' +
        '<button type="button" class="nana-close" aria-label="Fermer">' +
          '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
        '</button>' +
      '</header>' +
      '<div class="nana-body"><div class="nana-chat"></div><div class="nana-options"></div></div>' +
      '<form class="nana-bar" autocomplete="off">' +
        '<input class="nana-input" type="text" placeholder="Posez votre question" aria-label="Posez votre question">' +
        '<button type="button" class="nana-mic" aria-label="Dicter">' +
          '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="3" width="6" height="11" rx="3"/><path d="M5 11a7 7 0 0 0 14 0M12 18v3"/></svg>' +
        '</button>' +
        '<button type="submit" class="nana-send" aria-label="Envoyer">' +
          '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 19V5M6 11l6-6 6 6"/></svg>' +
        '</button>' +
      '</form>';
    return m;
  }

  // ===== moteur du diagnostic (code d'origine, branche sur la fenetre) =====
  function runDiagnostic(els, opts, api) {

    var chat = els.chat;
    var inputArea = els.options;

    var state = {
      prenom: "",
      dejaVenue: "",
      typeCheveux: "",
      textureCheveux: "",
      envieTexture: null,
      abimes: "",
      frequence: "",
      objectif: "",
      routine: "",
      stress: "",
      dernierSoin: "",
      satisfaiteDerniereFois: ""
    };

    var currentStepIndex = 0;
    var steps = [];

    var lienSoinClassique = "https://www.grenadinehair.com/products/soin-classique-cheveux-salon-coiffure-lyon";
    var lienSoinProfond   = "https://www.grenadinehair.com/products/soin-profond-cheveux-salon-coiffure-lyon";
    var lienLissage       = "https://www.grenadinehair.com/products/lissage-cheveux-salon-coiffure-lyon";
    var lienProgrammeFid  = "https://www.grenadinehair.com/pages/programme-de-fidelite-grenadine";
    var lienRegister      = "https://www.grenadinehair.com/account/register";
    var lienLogin         = "https://www.grenadinehair.com/account/login?error=login_required";

    function scrollToBottom() {
      chat.scrollTop = chat.scrollHeight;
    }

    function addMessage(text, sender) {
      var msg = document.createElement('div');
      msg.className = 'diag-message ' + (sender === 'user' ? 'diag-user' : 'diag-bot');
      msg.innerHTML = text;
      chat.appendChild(msg);
      scrollToBottom();
    }

    // bulle "en train d'écrire"
    function showTyping(duration, callback) {
      var typing = document.createElement('div');
      typing.className = 'diag-message diag-bot diag-typing';
      typing.innerHTML = '<span class="diag-typing-dot"></span><span class="diag-typing-dot"></span><span class="diag-typing-dot"></span>';
      chat.appendChild(typing);
      scrollToBottom();
      setTimeout(function() {
        if (typing.parentNode) typing.parentNode.removeChild(typing);
        if (callback) callback();
      }, duration || 800);
    }

    function setInput(node) {
      inputArea.innerHTML = '';
      inputArea.appendChild(node);
    }

    function nextStep() {
      // on saute les questions deja repondues dans la question ouverte du debut
      while (currentStepIndex < steps.length && steps[currentStepIndex].champ &&
             state[steps[currentStepIndex].champ] !== "" && state[steps[currentStepIndex].champ] !== null) {
        currentStepIndex++;
      }
      if (currentStepIndex < steps.length) {
        var fn = steps[currentStepIndex];
        currentStepIndex++;
        setTimeout(fn, 400);
      } else {
        setTimeout(showResult, 500);
      }
    }

    // Étape 1 : prénom
    function stepPrenom() {
      showTyping(900, function() {
        addMessage("Bonjour, je suis <strong>Nana</strong> 🩷<br>Comment vous appelez-vous ?", "bot");
      });

      var wrapperInput = document.createElement('div');
      wrapperInput.className = 'diag-input-row';

      var input = document.createElement('input');
      input.type = 'text';
      input.placeholder = 'Entrez votre prénom';
      input.className = 'diag-text-input';

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'diag-btn';
      btn.textContent = 'Valider';

      btn.addEventListener('click', function() {
        var value = (input.value || '').trim();
        if (!value) {
          input.focus();
          return;
        }
        state.prenom = value;
        state.prenomTape = true;
        state.presentee = true;
        addMessage(value, 'user');
        nextStep();
      });

      input.addEventListener('keypress', function(e) {
        if (e.key === 'Enter') {
          btn.click();
        }
      });

      wrapperInput.appendChild(input);
      wrapperInput.appendChild(btn);
      setInput(wrapperInput);
      input.focus();
    }

    // ===== Question ouverte du debut (facon cuure) =====
    // La cliente decrit ses cheveux avec ses mots. On en deduit ce qu'on peut
    // (texture, epaisseur, abimes, objectif, envie de lissage, stress) : les
    // questions correspondantes sont ensuite sautees.
    function sansAccent(t) { return (t || "").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, ""); }

    function analyser(texte) {
      var t = " " + sansAccent(texte).replace(/[^a-z0-9]+/g, " ") + " ";
      var adj = [], but = "", stressee = false;

      if (/ (crepu|crepus|crepue|crepues|afro|4a|4b|4c|coily) |tres fris/.test(t)) { state.textureCheveux = "afro"; adj.push("afro / crépus"); }
      else if (/ (frise|frises|frisee|frisees) /.test(t)) { state.textureCheveux = "frises"; adj.push("frisés"); }
      else if (/boucl|ondul|wavy|curly/.test(t)) { state.textureCheveux = "boucles"; adj.push("bouclés"); }
      else if (/ (lisse|lisses|raide|raides) /.test(t)) { state.textureCheveux = "lisses"; adj.push("lisses"); }

      if (/ (fins|fine|fines) |cheveux fin /.test(t)) { state.typeCheveux = "fins"; adj.push("fins"); }
      else if (/epais|volumineu|beaucoup de cheveux|dense/.test(t)) { state.typeCheveux = "epais"; adj.push("épais"); }

      if (/pas (vraiment |trop |du tout )?abim|bonne sante/.test(t)) { state.abimes = "non"; }
      else if (/abim|sec |secs|seche|cass|fourch|brul|cram|decolor|fragile/.test(t)) { state.abimes = "oui"; adj.push(/abim|cass|fourch|brul|cram|decolor|fragile/.test(t) ? "abîmés" : "secs"); }

      if (/lisser|lissage|bresilien|keratine|tanin/.test(t)) {
        state.objectif = "lisser"; but = "les lisser durablement";
        if (state.textureCheveux && state.textureCheveux !== "lisses") state.envieTexture = "lisser_durablement";
      } else if (/repar|renforc|cass|fourch|abim/.test(t)) { state.objectif = "reparer"; but = "les réparer"; }
      else if (/hydrat|nourri|sec |secs|seche|douceur|doux/.test(t)) { state.objectif = "hydrater"; but = "les hydrater"; }
      else if (/defini|frisottis|discipl|gonfl|indomptable/.test(t)) { state.objectif = "discipline"; but = "les discipliner"; }
      else if (/brill|eclat|terne/.test(t)) { state.objectif = "brillance"; but = "leur redonner de la brillance"; }

      if (state.textureCheveux && state.textureCheveux !== "lisses" && state.envieTexture === null) {
        if (/brushing/.test(t)) state.envieTexture = "brushing";
        else if (/garder|naturel|defini/.test(t)) state.envieTexture = "garder";
      }

      if (/stress|anxi|surmen|epuise/.test(t)) { state.stress = "oui"; stressee = true; }

      // questions pratiques posees en meme temps
      var infos = [];
      if (/prix|tarif|combien|cout|coute/.test(t)) infos.push("Les prix sont indiqués sur chaque prestation : je vous donne le lien à la fin 🩷");
      if (/ (horaire|horaires|ouvert|ouverte|ouverture|ouvrez|ferme|fermez) |quel jour|quels jours/.test(t)) infos.push("Le salon est ouvert du mardi au samedi, de 9h à 19h (sauf le mercredi).");
      if (/adresse|ou est|ou se trouve|situe|venir|metro/.test(t)) infos.push("Le salon se trouve 4 place du Général Brosset, à Lyon 6.");
      if (/couleur|coloration|balayage|meche|blond/.test(t)) infos.push("Nous ne faisons pas de coloration ni de balayage : uniquement des soins, des coupes et des lissages.");
      if (/enfant|fille|fils|ado/.test(t)) infos.push("Il n'y a pas de tarif enfant, mais l'adhésion GRENADINE+ couvre aussi votre enfant de moins de 16 ans.");

      return { adj: adj, but: but, stressee: stressee, infos: infos };
    }

    // Question hors sujet (pas sur les cheveux) : Nana repond simplement, puis revient aux cheveux
    function horsSujet(texte) {
      var t = " " + sansAccent(texte).replace(/[^a-z0-9?]+/g, " ") + " ";
      if (/fondat|createur|creatrice|cree grenadine|a cree|patronne|proprietaire|gerante|qui dirige/.test(t))
        return "Le plus important n'est pas de savoir <em>qui</em> a fondé GRENADINE, mais plutôt <strong>pourquoi</strong> 🩷 GRENADINE a été créé pour répondre à toutes les femmes, quels que soient leur type de cheveux, le résultat souhaité et leurs différences. C'est un endroit unique, pensé pour l'ensemble des femmes.";
      if (/coiffeuse|coiffeur|quelqu un|une personne|humain|vraie personne|conseillere|parler a|parler avec|equipe|appeler|telephone|numero|joindre/.test(t))
        return "Pour parler à une coiffeuse, appelez le salon au <a href='tel:+33986871171'><strong>09 86 87 11 71</strong></a>, du <strong>mardi au samedi de 9h à 19h</strong> (sauf le mercredi).";
      if (/horaire|ouvert|ouvrez|ferme|quel jour|quels jours|lundi|dimanche|samedi|week ?end/.test(t))
        return "Le salon est ouvert du <strong>mardi au samedi, de 9h à 19h</strong> (sauf le mercredi). Vous pouvez nous appeler au <a href='tel:+33986871171'><strong>09 86 87 11 71</strong></a>.";
      if (/adresse|ou est le salon|ou se trouve|ou etes vous|situe|metro|parking/.test(t))
        return "Le salon se trouve <strong>4 place du Général Brosset, à Lyon 6</strong>.";
      if (/contact|mail /.test(t))
        return "Appelez le salon au <a href='tel:+33986871171'><strong>09 86 87 11 71</strong></a>, du <strong>mardi au samedi de 9h à 19h</strong> (sauf le mercredi). Vous pouvez aussi écrire depuis la page <a href='/pages/contact-1'>Contact</a>.";
      if (/livraison|expedi|frais de port|colis/.test(t))
        return "La livraison est offerte dès <strong>100 €</strong> de produits, et le retrait au salon est possible.";
      if (/grenadine ?\+|grenadine plus|adhesion|programme|fidelite/.test(t))
        return "GRENADINE+ coûte <strong>29,90 € pour 1 an</strong> : −20 € sur chaque prestation, réservation 3 mois à l'avance et votre enfant de moins de 16 ans inclus. <a href='/pages/programme-de-fidelite-grenadine'>Tout savoir</a>";
      if (/prix|tarif|combien|cout|coute/.test(t))
        return "Tous les prix sont sur la page <a href='/pages/coiffeur-lyon-reservation'>Nos prestations</a>, et je vous donne le vôtre à la fin 🩷";
      if (/couleur|coloration|balayage|meche|blond/.test(t))
        return "Nous ne faisons pas de coloration ni de balayage : uniquement des soins, des coupes et des lissages.";
      if (/\?/.test(texte) || /^ (qui|quoi|quand|pourquoi|comment|est ce|c est quoi) /.test(t))
        return (horsSujet.dit++ ? "Pour ça, le mieux est d'appeler le salon au <a href='tel:+33986871171'><strong>09 86 87 11 71</strong></a>, du mardi au samedi de 9h à 19h (sauf le mercredi)."
          : "Ça, je ne saurais pas vous répondre. Moi, je suis là pour vos cheveux. Pour le reste, l'équipe vous répond au <a href='tel:+33986871171'><strong>09 86 87 11 71</strong></a>, du mardi au samedi de 9h à 19h (sauf le mercredi).");
      return null;
    }
    horsSujet.dit = 0;

    // Questions sur les soins (reponses d'Oriana, 2026-10-18)
    function faqSoins(texte) {
      var t = " " + sansAccent(texte).replace(/[^a-z0-9?]+/g, " ") + " ";
      var question = /\?/.test(texte) || /^ (c est quoi|quelle|quel|quels|quelles|est ce|est il|y a t il|il y a|combien|pourquoi|comment|ca coute|on peut|je peux|peut on) /.test(t);
      if (!question) return null;
      var r = [];
      if (/differen|compar|ou bien|ou un soin|plutot/.test(t) && /classique/.test(t) && /profond/.test(t))
        r.push("Le <strong>soin classique</strong> est un soin d'entretien : il permet d'entretenir vos cheveux. Le <strong>soin profond</strong>, lui, va hydrater, nourrir ou réparer vos cheveux, en fonction du soin profond choisi.");
      if (/plusieurs|differents soins|types? de soin|sortes? de soin|lequel|laquelle|quel soin|choisir|choix/.test(t))
        r.push("Oui, il existe plusieurs soins classiques et plusieurs soins profonds 🌸 Mais vous ne choisissez pas à l'avance : c'est une fois au salon que votre coiffeuse et vous choisissez ensemble le soin qui convient à vos cheveux.");
      if (/ dure | durent |duree|combien de temps|meme temps|longtemps/.test(t) && !/lissage/.test(t))
        r.push("Rassurez-vous : tous les soins classiques durent le même temps, et le choix du soin ne change pas le prix.");
      if (/longueur|longs?|courts?|mi long|epaule/.test(t) && /prix|tarif|cher|payer|paye|coute|cout|plus|meme|difference/.test(t))
        r.push("Il n'y a pas de différence de prix selon la longueur de vos cheveux : c'est un tarif unique.");
      else if (/prix affiche|meme prix|payer plus|paye plus|supplement|prix final|plus cher|surprise|frais|prix change|prix sera/.test(t))
        r.push("Le prix affiché est celui que vous payez, sauf si vous ajoutez des options.");
      return r.length ? r.join("<br>") : null;
    }
    function parleCheveux(texte) {
      return /cheveu|boucl|fris|crep|lisse|lissage|raide|abim|sec|seche|fourch|cass|soin|coupe|brushing|pointe|longueur|racine|cuir|volume|frisottis|hydrat|brill|terne|epais|fin|ondul|afro/.test(sansAccent(texte));
    }

    var dejaSalue = false;
    function salutation() {
      if (dejaSalue) return "";
      dejaSalue = true;
      var p = state.prenom ? state.prenom.charAt(0).toUpperCase() + state.prenom.slice(1) : "";
      if (state.prenomTape) return "Enchantée " + esc(p) + " 🩷 ";
      return (p ? "Bonjour " + esc(p) + " 🩷 " : "Bonjour 🩷 ");
    }

    function liste(mots) {
      if (mots.length < 2) return mots.join("");
      return mots.slice(0, -1).join(", ") + " et " + mots[mots.length - 1];
    }

    // Une seule bulle : bonjour + ce que Nana a compris + infos pratiques, puis la question suivante
    function repondreOuverte(texte) {
      api.onFree = null;
      var r = analyser(texte);
      var phrases = [];
      if (r.adj.length) phrases.push("vos cheveux sont <strong>" + liste(r.adj) + "</strong>");
      if (r.but) phrases.push("vous aimeriez <strong>" + r.but + "</strong>");
      var msg = salutation();
      if (phrases.length) {
        msg += "C'est noté : " + phrases.join(", ") + (r.stressee ? ", dans une période un peu stressante" : "") + ".";
      } else {
        msg += "Merci de m'en avoir parlé.";
      }
      if (r.infos.length) msg += "<br>" + r.infos.join("<br>");
      msg += state.presentee
        ? "<br>Je vais vous poser quelques questions pour bien comprendre vos cheveux et vous conseiller le soin qui vous correspond 🌸"
        : "<br>Je me présente : je suis <strong>Nana</strong>, votre mamie des cheveux 🌸 Je vais vous poser quelques questions pour bien comprendre vos cheveux et vous conseiller le soin qui vous correspond.";
      state.presentee = true;
      showTyping(1100, function() {
        addMessage(msg, "bot");
        nextStep();
      });
    }

    // Cliente connectee deja venue : merci + rappel "tous les 3 mois" (une seule fois)
    function phraseDiagnostic(dx) {
      if (!dx) return "";
      var quand = "";
      if (dx.date) {
        var d = new Date(dx.date + "T12:00:00");
        if (!isNaN(d)) quand = " du <strong>" + d.toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" }) + "</strong>";
      }
      var traits = [];
      if (dx.type) traits.push("type " + esc(dx.type));
      var natTxt = { "Fin": "fins", "Moyen": "d'épaisseur moyenne", "Épais": "épais" }[dx.nature];
      if (natTxt) traits.push(natTxt);
      (dx.etat || []).forEach(function (e) {
        var x = String(e).replace(/^Cheveux /i, "").replace("abîmés/cassants", "abîmés").replace("méchés/décolorés", "méchés").toLowerCase();
        if (x && x !== "normaux") traits.push(esc(x));
      });
      var soin = dx.profond ? "le " + esc(dx.profond) : dx.lissage ? "le lissage " + esc(dx.lissage) : dx.classique ? "le soin " + esc(dx.classique) : "";
      var m = "J'ai aussi retrouvé votre diagnostic" + quand + (dx.coiffeuse ? " avec <strong>" + esc(dx.coiffeuse) + "</strong>" : "") + ".";
      if (traits.length) m += " Vos cheveux : <strong>" + traits.join(", ") + "</strong>.";
      if (soin) m += " Soin réalisé : <strong>" + soin + "</strong>.";
      return m;
    }

    function messageFidelite() {
      var f = state.fid;
      if (!f || (!f.visites && !f.diag) || state.fidDit) return "";
      state.fidDit = true;
      state.presentee = true;
      var jour = 86400, moisS = 30.4 * jour;
      var noms = { classique: "un soin classique", profond: "un soin profond", lissage: "un lissage" };
      function dateFr(ts) { return new Date(ts * 1000).toLocaleDateString("fr-FR", { day: "numeric", month: "long" }); }
      function duree(n) { return n <= 1 ? "1 mois" : n + " mois"; }
      var fois = f.visites === 1 ? "une fois" : "<strong>" + f.visites + " fois</strong>";
      var depuis = f.dernier ? Math.max(0, Math.round((f.maintenant - f.dernier) / moisS)) : 0;

      var m = salutation() + "Je suis <strong>Nana</strong>, votre mamie des cheveux. " +
        "Je me suis permise d'aller voir dans votre fichier" +
        (f.visites ? " : vous êtes déjà venue " + fois + " chez nous, merci pour votre confiance !" : ".");
      var dxm = phraseDiagnostic(f.diag);
      if (dxm) m += "<hr class='nana-sep'>" + dxm;

      if (!f.visites) return m;
      // ce que Nana a vu : regularite
      m += "<hr class='nana-sep'>";
      var reguliere = false;
      if (f.visites >= 2 && f.premier && f.dernier > f.premier) {
        var rythme = Math.max(1, Math.round((f.dernier - f.premier) / (f.visites - 1) / moisS));
        reguliere = rythme <= 4 && depuis <= 4;
        m += "Vous venez en moyenne <strong>tous les " + (rythme === 1 ? "mois" : rythme + " mois") + "</strong>";
        m += reguliere
          ? " : vous êtes très régulière, bravo 👏 C'est exactement ce dont vos cheveux ont besoin."
          : (rythme > 4 ? " : c'est un peu espacé pour vos cheveux. L'idéal, c'est tous les 3 mois." : ", mais votre dernière visite date un peu.");
      } else {
        m += "C'était votre première visite" + (depuis ? " il y a " + duree(depuis) : "") + " : on a hâte de vous revoir !";
      }
      if (f.type && noms[f.type] && !f.diag) {
        m += "<br>Votre dernier soin : <strong>" + noms[f.type] + "</strong>" + (depuis && depuis < 3 ? ", il y a " + duree(depuis) : "") + ".";
      }

      // prochaine etape (dite en dernier, apres le conseil : Oriana 2026-10-18)
      var etape = "";
      if (f.prochain) {
        etape += "Votre prochain rendez-vous est prévu le <strong>" + dateFr(f.prochain) + "</strong>, on a hâte de vous revoir 🌸";
      } else if (depuis >= 3) {
        etape += "Votre dernier passage remonte à <strong>" + duree(depuis) + "</strong> : c'est le bon moment pour revenir 🌸";
      } else if (f.dernier) {
        etape += "Votre prochain soin est conseillé à partir du <strong>" + dateFr(f.dernier + 91 * jour) + "</strong> 🌸";
      }

      // conseil : dit plus tard, apres le resultat (Oriana 2026-10-18 : "personne t'a rien demande")
      state.fidApres = [];
      if (etape) state.fidApres.push(etape);
      state.fidApres.push("Mon conseil : un soin d'entretien <strong>tous les 3 mois</strong> " +
        (f.type === "classique" && reguliere
          ? "et, de temps en temps, un <strong>soin profond</strong> à la place du soin classique pour réparer en profondeur"
          : "(le <strong>soin classique</strong>, ou encore mieux le <strong>soin profond</strong>)") +
        ", avec la coupe des pointes ✂️");
      return m;
    }

    function stepOuverte() {
      // la cliente a ouvert Nana avec une question hors sujet : on lui repond d'abord
      var rep0 = opts.firstRaw && (faqSoins(opts.firstRaw) || (!parleCheveux(opts.firstRaw) && horsSujet(opts.firstRaw)));
      if (rep0) {
        opts.firstRaw = "";
        showTyping(1200, function() {
          proposerSuite(salutation() + rep0);
        });
        return;
      }
      suiteFidelite();
    }

    // "Reserver un rendez-vous" : le lien, puis "savez-vous quel soin choisir ?"
    function reponseReserver() {
      api.onFree = null; // "oui" / "non" tape en bas = les boutons
      var lien = "<a href='/pages/coiffeur-lyon-reservation'><strong>Cliquez ici pour réserver votre rendez-vous</strong></a>";
      showTyping(900, function () {
        addMessage("Bien sûr 🩷 " + lien + ".", "bot");
        setTimeout(function () {
          showTyping(1000, function () {
            addMessage("Savez-vous quel soin choisir ?", "bot");
            var row = document.createElement('div');
            row.className = 'diag-input-row';
            [
              ["Oui, je sais", function () {
                inputArea.innerHTML = '';
                showTyping(900, function () { proposerSuite("Parfait 🌸 Il ne vous reste plus qu'à choisir votre date : <a href='/pages/coiffeur-lyon-reservation'><strong>cliquez ici</strong></a>."); });
              }],
              ["Non, aidez-moi", function () { inputArea.innerHTML = ''; suiteFidelite(); }]
            ].forEach(function (c) {
              var b = document.createElement('button');
              b.type = 'button';
              b.className = 'diag-btn';
              b.textContent = c[0];
              b.addEventListener('click', function () { addMessage(esc(c[0]), 'user'); c[1](); });
              row.appendChild(b);
            });
            setInput(row);
          });
        }, 400);
      });
    }

    // Question ouverte : on repond, puis "je peux faire autre chose pour vous ?" avec des propositions
    // (pas de fichier client ni de quiz tant qu'elle ne l'a pas demande : Oriana 2026-10-18)
    function proposerSuite(reponse) {
      addMessage(reponse, "bot");
      setTimeout(function () {
        showTyping(900, function () {
          addMessage("Je peux faire autre chose pour vous ?", "bot");
          var row = document.createElement('div');
          row.className = 'diag-input-row';
          [
            ["Trouver mon soin", function () { inputArea.innerHTML = ''; suiteFidelite(); }],
            ["Réserver un rendez-vous", function () { inputArea.innerHTML = ''; reponseReserver(); }],
            ["Appeler le salon", function () {
              inputArea.innerHTML = '';
              showTyping(900, function () { proposerSuite("Bien sûr 🩷 Appelez le salon au <a href='tel:+33986871171'><strong>09 86 87 11 71</strong></a>, du mardi au samedi de 9h à 19h (sauf le mercredi)."); });
            }],
            ["Une autre question", function () { inputArea.innerHTML = ''; showTyping(700, function () { addMessage("Je vous écoute 🌸 Écrivez votre question en bas.", "bot"); }); }]
          ].forEach(function (c) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'diag-btn';
            b.textContent = c[0];
            b.addEventListener('click', function () { addMessage(esc(c[0]), 'user'); c[1](); });
            row.appendChild(b);
          });
          setInput(row);
          api.onFree = function (texte) {
            addMessage(esc(texte), 'user');
            var hs = faqSoins(texte) || (!parleCheveux(texte) && horsSujet(texte));
            inputArea.innerHTML = '';
            if (hs) { showTyping(1100, function () { proposerSuite(hs); }); return; }
            repondreOuverte(texte);
          };
        });
      }, 400);
    }

    function suiteFidelite() {
      var fidelite = messageFidelite();
      if (fidelite) {
        // une bulle par idee, avec "en train d'ecrire" a chaque fois, comme une vraie personne
        var bulles = fidelite.split("<hr class='nana-sep'>");
        (function suivante(i) {
          if (i >= bulles.length) { suiteOuverte(); return; }
          var txt = bulles[i].replace(/<[^>]+>/g, "");
          showTyping(Math.min(3200, 900 + txt.length * 18), function() {
            addMessage(bulles[i], "bot");
            setTimeout(function() { suivante(i + 1); }, 450);
          });
        })(0);
      } else {
        suiteOuverte();
      }
    }

    function suiteOuverte() {
      if (opts.firstRaw) {
        // la cliente a deja ecrit sa demande en ouvrant Nana
        var dejaDit = opts.firstRaw;
        opts.firstRaw = "";
        repondreOuverte(dejaDit);
        return;
      }
      showTyping(1000, function() {
        addMessage(salutation() + "Dites-moi tout : comment sont vos cheveux en ce moment, et qu'aimeriez-vous changer ?<br>" +
          "Écrivez librement en bas, ou choisissez une idée 👇", "bot");
      });

      var wrapperInput = document.createElement('div');
      wrapperInput.className = 'diag-input-row';
      ["Mes cheveux sont abîmés", "Je veux un lissage", "Définir mes boucles", "Mes cheveux sont secs", "Je ne sais pas trop"].forEach(function (idee) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'diag-btn';
        btn.textContent = idee;
        btn.addEventListener('click', function() {
          addMessage(esc(idee), 'user');
          inputArea.innerHTML = '';
          repondreOuverte(idee);
        });
        wrapperInput.appendChild(btn);
      });
      setInput(wrapperInput);

      // texte libre tape dans la barre du bas
      api.onFree = function (texte) {
        addMessage(esc(texte), 'user');
        var hs = faqSoins(texte) || (!parleCheveux(texte) && horsSujet(texte));
        if (hs) {
          inputArea.innerHTML = '';
          showTyping(1100, function() { proposerSuite(hs); });
          return;
        }
        inputArea.innerHTML = '';
        repondreOuverte(texte);
      };
    }

    // Étape 2 : déjà venue ou première fois
    function stepDejaVenue() {
      var name = state.prenom ? state.prenom.charAt(0).toUpperCase() + state.prenom.slice(1) : "Belle cliente";
      showTyping(900, function() {
        addMessage(name + ", est-ce votre première fois chez GRENADINE ou êtes-vous déjà venue au salon ?", "bot");
      });

      var wrapperInput = document.createElement('div');
      wrapperInput.className = 'diag-input-row';

      var options = [
        { value: "premiere", label: "C’est ma première fois" },
        { value: "deja", label: "Je suis déjà venue" }
      ];

      options.forEach(function(opt) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'diag-btn';
        btn.textContent = opt.label;
        btn.addEventListener('click', function() {

          state.dejaVenue = opt.value;
          addMessage(opt.label, 'user');

          if (opt.value === "premiere") {
            // une seule bulle (Oriana) ; si Nana s'est deja presentee, on ne le repete pas
            showTyping(1000, function() {
              addMessage(state.presentee
                ? "Enchantée, et bienvenue chez <strong>GRENADINE</strong> 🩷 Rassurez-vous, j'ai beaucoup d'expérience en coiffure : je vais vous aider à trouver ce qui manque à vos cheveux."
                : "Enchantée ! Je suis <strong>Nana</strong>, votre mamie des cheveux 🩷 Rassurez-vous, j'ai beaucoup d'expérience en coiffure : je vais vous aider à trouver ce qui manque à vos cheveux.", "bot");
              nextStep();
            });
          } else {
            showTyping(900, function() {
              addMessage("Ah super, ravie de vous revoir 🩷", "bot");
              nextStep();
            });
          }
        });
        wrapperInput.appendChild(btn);
      });

      setInput(wrapperInput);
    }

    // Étape 3 : pour les clientes déjà venues – dernière prestation & satisfaction
    function stepDerniereFois() {
      if (state.dejaVenue !== "deja") {
        nextStep();
        return;
      }

      var dejaConnu = !!state.dernierSoin;
      var nomsSoin = { classique: "un <strong>soin classique</strong>", profond: "un <strong>soin profond</strong>", lissage: "un <strong>lissage</strong>" };
      showTyping(800, function() {
        // deja dit dans la bulle "fichier" : on ne le repete pas
        if (!(dejaConnu && state.fidDit)) {
          addMessage(dejaConnu
            ? "La dernière fois, vous étiez venue pour " + nomsSoin[state.dernierSoin] + " 🩷"
            : "Qu’est-ce que vous aviez fait la fois d’avant ?", "bot");
        }
      });

      var wrapperInput = document.createElement('div');
      wrapperInput.className = 'diag-input-row';

      var optionsPresta = [
        { value: "classique", label: "Soin classique" },
        { value: "profond", label: "Soin profond" },
        { value: "lissage", label: "Lissage" },
        { value: "autre", label: "Autre / je ne sais plus" }
      ];

      function askSatisfaction() {
        showTyping(800, function() {
          addMessage("Et est-ce que vous aviez été satisfaite du soin ?", "bot");
        });

        var satWrapper = document.createElement('div');
        satWrapper.className = 'diag-input-row';

        var optionsSat = [
          { value: "oui", label: "Oui, très satisfaite" },
          { value: "non", label: "Pas complètement satisfaite" }
        ];

        optionsSat.forEach(function(opt) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'diag-btn';
          btn.textContent = opt.label;
          btn.addEventListener('click', function() {
            state.satisfaiteDerniereFois = opt.value;
            addMessage(opt.label, 'user');

            if (opt.value === "oui") {
              showTyping(800, function() {
                addMessage("Top, ça me fait plaisir 🩷 On va rester dans cette continuité en affinant encore plus pour vous.", "bot");
                nextStep();
              });
            } else {
              showTyping(800, function() {
                addMessage("Merci de me le dire, c’est important pour nous. On va ajuster pour que cette fois-ci ce soit vraiment parfait pour vous ✨", "bot");
                nextStep();
              });
            }
          });
          satWrapper.appendChild(btn);
        });

        setInput(satWrapper);
      }

      optionsPresta.forEach(function(opt) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'diag-btn';
        btn.textContent = opt.label;
        btn.addEventListener('click', function() {
          state.dernierSoin = opt.value;
          addMessage(opt.label, 'user');
          askSatisfaction();
        });
        wrapperInput.appendChild(btn);
      });

      if (dejaConnu) { askSatisfaction(); } else { setInput(wrapperInput); }
    }

    // Étape 4 : nature du cheveu
    function stepTypeCheveux() {
      showTyping(900, function() {
        addMessage("Parlons d’abord de la nature de vos cheveux : ils sont plutôt…", "bot");
      });

      var wrapperInput = document.createElement('div');
      wrapperInput.className = 'diag-input-row';

      var options = [
        { value: "fins", label: "Fins" },
        { value: "normaux", label: "Normaux" },
        { value: "epais", label: "Épais" }
      ];

      options.forEach(function(opt) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'diag-btn';
        btn.textContent = opt.label;
        btn.addEventListener('click', function() {
          state.typeCheveux = opt.value;
          addMessage(opt.label, 'user');
          nextStep();
        });
        wrapperInput.appendChild(btn);
      });

      setInput(wrapperInput);
    }

    // Étape 5 : texture
    function stepTextureCheveux() {
      showTyping(800, function() {
        addMessage("Et au niveau de la texture, comment sont vos cheveux naturellement ?", "bot");
      });

      var wrapperInput = document.createElement('div');
      wrapperInput.className = 'diag-input-row';

      var options = [
        { value: "lisses", label: "Lisses" },
        { value: "boucles", label: "Bouclés" },
        { value: "frises", label: "Frisés" },
        { value: "afro", label: "Afro / très frisés" }
      ];

      options.forEach(function(opt) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'diag-btn';
        btn.textContent = opt.label;
        btn.addEventListener('click', function() {
          state.textureCheveux = opt.value;
          addMessage(opt.label, 'user');
          nextStep();
        });
        wrapperInput.appendChild(btn);
      });

      setInput(wrapperInput);
    }

    // Étape 6 : envie par rapport à la texture
    function stepEnvieTexture() {
      if (state.textureCheveux === "lisses" || !state.textureCheveux) {
        state.envieTexture = null;
        nextStep();
        return;
      }

      var desc = "vos cheveux texturés";
      if (state.textureCheveux === "boucles") desc = "vos cheveux bouclés";
      if (state.textureCheveux === "frises") desc = "vos cheveux frisés";
      if (state.textureCheveux === "afro") desc = "vos cheveux afro";

      showTyping(800, function() {
        addMessage("Et par rapport à " + desc + ", qu’est-ce que vous souhaitez ?", "bot");
      });

      var wrapperInput = document.createElement('div');
      wrapperInput.className = 'diag-input-row';

      var options = [
        { value: "garder", label: "Garder ma texture naturelle" },
        { value: "brushing", label: "Juste un brushing ponctuel" },
        { value: "lisser_durablement", label: "Les lisser durablement (lissage)" }
      ];

      options.forEach(function(opt) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'diag-btn';
        btn.textContent = opt.label;
        btn.addEventListener('click', function() {
          state.envieTexture = opt.value;
          addMessage(opt.label, 'user');
          nextStep();
        });
        wrapperInput.appendChild(btn);
      });

      setInput(wrapperInput);
    }

    // Étape 7 : cheveux abîmés ?
    function stepCheveuxAbimes() {
      showTyping(800, function() {
        addMessage("Vos cheveux sont-ils abîmés, secs ou cassants actuellement ?", "bot");
      });

      var wrapperInput = document.createElement('div');
      wrapperInput.className = 'diag-input-row';

      var options = [
        { value: "oui", label: "Oui, ils sont abîmés et secs" },
        { value: "non", label: "Non, pas spécialement abîmés" }
      ];

      options.forEach(function(opt) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'diag-btn';
        btn.textContent = opt.label;
        btn.addEventListener('click', function() {
          state.abimes = opt.value;
          addMessage(opt.label, 'user');
          nextStep();
        });
        wrapperInput.appendChild(btn);
      });

      setInput(wrapperInput);
    }

    // Étape 8 : fréquence salon
    function stepFrequence() {
      showTyping(800, function() {
        addMessage("En moyenne, à quelle fréquence venez-vous chez le coiffeur ?", "bot");
      });

      var wrapperInput = document.createElement('div');
      wrapperInput.className = 'diag-input-row';

      var options = [
        { value: "moins1", label: "Moins d’une fois par an" },
        { value: "1a3", label: "1 à 3 fois par an" },
        { value: "plus3", label: "Plus de 3 fois par an" }
      ];

      options.forEach(function(opt) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'diag-btn';
        btn.textContent = opt.label;
        btn.addEventListener('click', function() {
          state.frequence = opt.value;
          addMessage(opt.label, 'user');
          nextStep();
        });
        wrapperInput.appendChild(btn);
      });

      setInput(wrapperInput);
    }

    // Étape 9 : objectif
    function stepObjectif() {
      showTyping(800, function() {
        addMessage("Quel est votre objectif principal pour vos cheveux en ce moment ?", "bot");
      });

      var wrapperInput = document.createElement('div');
      wrapperInput.className = 'diag-input-row';

      var options = [
        { value: "reparer", label: "Réparer et renforcer" },
        { value: "hydrater", label: "Hydrater et nourrir" },
        { value: "brillance", label: "Gagner en brillance" },
        { value: "discipline", label: "Discipliner / définir les boucles" },
        { value: "lisser", label: "Les lisser durablement" }
      ];

      options.forEach(function(opt) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'diag-btn';
        btn.textContent = opt.label;
        btn.addEventListener('click', function() {
          state.objectif = opt.value;
          addMessage(opt.label, 'user');
          nextStep();
        });
        wrapperInput.appendChild(btn);
      });

      setInput(wrapperInput);
    }

    // Étape 10 : routine
    function stepRoutine() {
      showTyping(800, function() {
        addMessage("Et à la maison, comment décririez-vous votre routine capillaire ?", "bot");
      });

      var wrapperInput = document.createElement('div');
      wrapperInput.className = 'diag-input-row';

      var options = [
        { value: "pro_regulier", label: "J’utilise des soins pro régulièrement" },
        { value: "pro_rarement", label: "J’utilise des soins pro de temps en temps" },
        { value: "simple", label: "Routine très simple, peu de soins" }
      ];

      options.forEach(function(opt) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'diag-btn';
        btn.textContent = opt.label;
        btn.addEventListener('click', function() {
          state.routine = opt.value;
          addMessage(opt.label, 'user');
          nextStep();
        });
        wrapperInput.appendChild(btn);
      });

      setInput(wrapperInput);
    }

    // Étape 11 : stress
    function stepStress() {
      showTyping(800, function() {
        addMessage("Et en ce moment, vous vous sentez plutôt stressée ou ça va ?", "bot");
      });

      var wrapperInput = document.createElement('div');
      wrapperInput.className = 'diag-input-row';

      var options = [
        { value: "oui", label: "Oui, je suis assez stressée" },
        { value: "non", label: "Non, ça va" }
      ];

      options.forEach(function(opt) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'diag-btn';
        btn.textContent = opt.label;
        btn.addEventListener('click', function() {
          state.stress = opt.value;
          addMessage(opt.label, 'user');
          nextStep();
        });
        wrapperInput.appendChild(btn);
      });

      setInput(wrapperInput);
    }

    // Helper pour prix exemple
    function formatEuro(n) {
      return n.toFixed(2).replace('.', ',') + " €";
    }

    // RÉSULTAT FINAL
    function showResult() {

      var prenomAffiche = state.prenom
        ? state.prenom.charAt(0).toUpperCase() + state.prenom.slice(1)
        : "";

      var estTextureBouclee =
        state.textureCheveux === "boucles" ||
        state.textureCheveux === "frises" ||
        state.textureCheveux === "afro";

      // ---- choix du soin (meme logique qu'avant, textes raccourcis) ----
      var mainPresta, pourquoi, ensuite;
      if (estTextureBouclee && state.envieTexture === "lisser_durablement") {
        mainPresta = "lissage";
        pourquoi = "Vous voulez lisser durablement vos cheveux : le lissage discipline la fibre et réduit volume et frisottis pendant 4 à 6 mois.";
        ensuite = (state.abimes === "oui" || state.frequence !== "plus3")
          ? "Ensuite : un <strong>soin profond</strong> pour garder des longueurs souples et brillantes."
          : "Ensuite : un <strong>soin classique</strong> tous les 3 mois pour l'entretenir.";
      } else if (state.abimes === "oui") {
        mainPresta = "profond";
        pourquoi = "Vos cheveux sont abîmés : il répare la fibre en profondeur grâce au Spa Mist II, une vapeur japonaise. Effet 2 à 3 mois.";
        ensuite = "Ensuite : un <strong>soin classique</strong> tous les 3 mois et la coupe des pointes ✂️";
      } else if (state.frequence === "moins1" || state.routine === "simple") {
        mainPresta = "profond";
        pourquoi = "Vous venez peu souvent : un vrai coup de boost qui répare et hydrate durablement (2 à 3 mois).";
        ensuite = "Ensuite : un <strong>soin classique</strong> tous les 3 mois et la coupe des pointes ✂️";
      } else {
        mainPresta = "classique";
        pourquoi = "Vos cheveux vont bien : c'est le soin d'entretien idéal pour la brillance et la douceur. Votre coiffeuse choisit le soin adapté sur place.";
        ensuite = "Tous les 3 mois, avec la coupe des pointes ✂️ Un <strong>soin profond</strong> de temps en temps, c'est encore mieux.";
      }

      var SOINS = {
        classique: { nom: "Soin classique", prix: 70, lien: "https://www.grenadinehair.com/products/soin-classique-cheveux-salon-coiffure-lyon" },
        profond:   { nom: "Soin profond",   prix: 160, lien: "https://www.grenadinehair.com/products/soin-profond-cheveux-salon-coiffure-lyon" },
        lissage:   { nom: "Lissage",        prix: 260, lien: "https://www.grenadinehair.com/products/lissage-cheveux-salon-coiffure-lyon" }
      };
      var CDN = "https://cdn.shopify.com/s/files/1/0729/3983/1631/files/";
      var PHOTOS = {
        classique: ["1_5dd1ff91-2617-498d-90ab-8dbbe7bed3fe.png?v=1763699016", "5_22bd651c-2222-448b-8586-2a4d1a69fc76.png?v=1763699016", "7_e438562f-804f-4e02-8ccf-4571b316173c.png?v=1763699017", "8_314e2f2b-82c4-4fef-b167-1bfa44f139f4.png?v=1763699016"],
        profond:   ["2_ed6743eb-3e94-4efc-a856-8fc306da62f5.png?v=1763699016", "3_739b543e-ffd8-4d83-9787-c0e6d46c9432.png?v=1763699016", "4_52b3e2ca-819f-4597-8056-c1d3c1258069.png?v=1763699016"],
        lissage:   ["6_e19e2df1-0754-438a-a0d1-49c8206135d0.png?v=1763699016", "cheveu_avant_et_apres_le_lissage_bresilien_de_chez_grenadine_salon_de_coiffure_a_lyon.png?v=1790092210"]
      };
      var soin = SOINS[mainPresta];
      var photos = PHOTOS[mainPresta].concat(PHOTOS.classique).slice(0, 4);
      function img(f, w) { return CDN + f + "&width=" + w; }
      function euro(n) { return (Math.round(n * 100) / 100).toFixed(2).replace(".", ",").replace(",00", "") + " €"; }

      // 1) le soin conseille : Nana le dit dans la conversation, bulle par bulle (Oriana 2026-10-18)
      var bullesSoin = [
        "Voilà" + (prenomAffiche ? " " + esc(prenomAffiche) : "") + " 🩷 Pour vous, le soin idéal, c'est le <strong>" + soin.nom.toLowerCase() + "</strong>, à partir de " + euro(soin.prix) + ".",
        "Pourquoi celui-ci ? " + pourquoi,
        ensuite
      ];
      var html = "<a class='nr-cta' href='" + soin.lien + "'>Réserver mon " + soin.nom.toLowerCase() + "</a>";

      // 2) resultats clientes
      html += "<div class='nr-results'><p class='nr-label'>Leurs résultats</p><div class='nr-strip'>";
      photos.slice(1, 4).forEach(function (f) {
        html += "<img src='" + img(f, 240) + "' alt='Résultat cliente GRENADINE' loading='lazy'>";
      });
      html += "</div></div>";

      // 3) paiement en plusieurs fois : schema anime
      html +=
        "<div class='nr-pay' data-prix='" + soin.prix + "'>" +
          "<div class='nr-pay-head'><p class='nr-label'>Payez en plusieurs fois</p>" +
            "<div class='nr-toggle' role='tablist'><button type='button' class='is-on' data-n='3'>3x</button><button type='button' data-n='4'>4x</button></div>" +
          "</div>" +
          "<p class='nr-pay-big'><span class='nr-pay-amount'></span><small> / mois</small></p>" +
          "<div class='nr-steps'></div>" +
          "<p class='nr-pay-note'>Exemple pour " + soin.nom.toLowerCase() + " à " + euro(soin.prix) + ". Avec Klarna, PayPal ou Alma au moment du paiement en ligne.</p>" +
        "</div>";

      // 4) GRENADINE+ : carte membre cliquable
      var prixMembre = soin.prix - 20;
      html +=
        "<a class='nr-gplus' href='" + lienProgrammeFid + "'>" +
          "<span class='nr-gplus-shine' aria-hidden='true'></span>" +
          "<span class='nr-gplus-top'><span class='nr-gplus-logo'>GRENADINE<b>+</b></span><span class='nr-gplus-tag'>Membre</span></span>" +
          "<span class='nr-gplus-deal'>−20 € sur chaque prestation</span>" +
          "<span class='nr-gplus-ex'>Votre " + soin.nom.toLowerCase() + " : <b>" + euro(prixMembre) + "</b> <s>" + euro(soin.prix) + "</s></span>" +
          "<span class='nr-gplus-perks'>" +
            "<span>Réservation 3 mois à l'avance</span><span>Annulation jusqu'à 24 h</span><span>Coupe pointes à 15 €</span><span>Votre enfant (−16 ans) inclus</span>" +
          "</span>" +
          "<span class='nr-gplus-foot'><span>29,90 € / an · rentabilisé dès la 2<sup>e</sup> visite</span><span class='nr-gplus-go' aria-hidden='true'>→</span></span>" +
        "</a>";

      // 5) compte
      if (state.dejaVenue === "premiere") {
        html += "<p class='nr-account'>Première visite ? <a href='" + lienRegister + "'>Créez votre espace GRENADINE</a> pour suivre vos rendez-vous et vos avantages.</p>";
      } else if (!state.fid) {
        html += "<p class='nr-account'><a href='" + lienLogin + "'>Connectez-vous</a> pour retrouver vos rendez-vous et vos avantages.</p>";
      }

      // 6) boucles
      if (estTextureBouclee && state.envieTexture !== "lisser_durablement") {
        html += "<p class='nr-account'>Vos boucles sont les bienvenues 🩷 On les sublime, et un brushing ponctuel reste toujours possible.</p>";
      }

      inputArea.innerHTML = '';
      var res = document.createElement('div');
      res.className = 'nana-result';
      res.innerHTML = html;
      res.style.display = 'none';
      chat.appendChild(res);

      // schema de paiement : n pastilles qui se remplissent l'une apres l'autre
      var pay = res.querySelector('.nr-pay');
      var steps = pay.querySelector('.nr-steps');
      var amount = pay.querySelector('.nr-pay-amount');
      var quand = ["Aujourd'hui", "Dans 1 mois", "Dans 2 mois", "Dans 3 mois"];
      function dessiner(n) {
        amount.textContent = euro(soin.prix / n);
        steps.className = 'nr-steps';
        steps.innerHTML = quand.slice(0, n).map(function (q, i) {
          return "<div class='nr-step' style='--i:" + i + "'><span class='nr-dot'></span><span class='nr-step-q'>" + q + "</span><span class='nr-step-v'>" + euro(soin.prix / n) + "</span></div>";
        }).join("");
        setTimeout(function () { steps.className = 'nr-steps is-go'; }, 60);
      }
      pay.querySelectorAll('.nr-toggle button').forEach(function (b) {
        b.addEventListener('click', function () {
          pay.querySelectorAll('.nr-toggle button').forEach(function (x) { x.classList.toggle('is-on', x === b); });
          dessiner(+b.getAttribute('data-n'));
        });
      });
      // les bulles du soin, puis le bouton reserver, les resultats, le paiement et GRENADINE+
      (function direSoin(i) {
        if (i >= bullesSoin.length) {
          chat.appendChild(res);
          res.style.display = '';
          dessiner(3);
          res.scrollIntoView({ behavior: 'smooth', block: 'start' });
          direApres();
          return;
        }
        showTyping(Math.min(3000, 900 + bullesSoin[i].replace(/<[^>]+>/g, "").length * 18), function () {
          addMessage(bullesSoin[i], "bot");
          setTimeout(function () { direSoin(i + 1); }, 450);
        });
      })(0);

      // ce que Nana garde pour la fin : dernier passage / prochain rdv, puis son conseil
      function direApres() {
      var apres = (state.fidApres || []).slice();
      state.fidApres = [];
      (function dire(i) {
        if (i >= apres.length) return;
        setTimeout(function () {
          showTyping(Math.min(3000, 900 + apres[i].replace(/<[^>]+>/g, "").length * 18), function () {
            addMessage(apres[i], "bot");
            dire(i + 1);
          });
        }, i ? 500 : 2500);
      })(0);
      }
    }

    stepDejaVenue.champ = "dejaVenue";
    stepTypeCheveux.champ = "typeCheveux";
    stepFrequence.champ = "frequence";
    stepTextureCheveux.champ = "textureCheveux";
    stepEnvieTexture.champ = "envieTexture";
    stepCheveuxAbimes.champ = "abimes";
    stepObjectif.champ = "objectif";
    stepStress.champ = "stress";

    steps = [
      stepPrenom,
      stepOuverte,
      stepDejaVenue,
      stepDerniereFois,
      stepTypeCheveux,
      stepTextureCheveux,
      stepEnvieTexture,
      stepCheveuxAbimes,
      stepFrequence,
      stepObjectif,
      stepRoutine,
      stepStress
    ];

    // Cliente connectee deja venue (commandes) : pas de "premiere fois ?", dernier soin connu
    // Dernier diagnostic du salon : on pre-remplit ce que la coiffeuse a deja note
    var dx = opts.fidelite && opts.fidelite.diag;
    if (dx) {
      state.fid = opts.fidelite;
      state.dejaVenue = "deja";
      var nat = { "Fin": "fins", "Moyen": "normaux", "Épais": "epais" }[dx.nature];
      if (nat) state.typeCheveux = nat;
      var ty = String(dx.type || "");
      if (/^1/.test(ty)) state.textureCheveux = "lisses";
      else if (/^2|^3[AB]/.test(ty)) state.textureCheveux = "boucles";
      else if (/^3C/.test(ty)) state.textureCheveux = "frises";
      else if (/^4/.test(ty)) state.textureCheveux = "afro";
      var etat = (dx.etat || []).join(" ");
      if (/abîmés|fourchues|secs/.test(etat) || dx.sensibilite === "Forte") state.abimes = "oui";
      else if (etat) state.abimes = "non";
      if ((dx.curly === true || dx.curly === "true") && state.textureCheveux && state.textureCheveux !== "lisses") state.envieTexture = "garder";
    }
    if (opts.fidelite && opts.fidelite.visites > 0) {
      state.fid = opts.fidelite;
      // frequence deduite du fichier (rythme moyen entre deux visites)
      var ff = opts.fidelite;
      if (ff.visites >= 2 && ff.premier && ff.dernier > ff.premier) {
        var parAn = 12 / Math.max(1, (ff.dernier - ff.premier) / (ff.visites - 1) / (30.4 * 86400));
        state.frequence = parAn > 3 ? "plus3" : parAn >= 1 ? "1a3" : "moins1";
      }
      state.dejaVenue = "deja";
      if (/^(classique|profond|lissage)$/.test(opts.fidelite.type)) state.dernierSoin = opts.fidelite.type;
    }

    // Prenom deja connu (cliente connectee) : on saute la question du prenom
    if (opts.prenom) {
      state.prenom = opts.prenom;
      steps.shift();
    }
    api.horsSujet = function (t) { return faqSoins(t) || (parleCheveux(t) ? null : horsSujet(t)); };
    api.isTextStep = function () { return !!inputArea.querySelector('.diag-text-input'); };
    api.state = state;

    setTimeout(function() {
      if (opts.firstMessage) { addMessage(opts.firstMessage, 'user'); }
      // le bonjour est dit dans la premiere bulle de Nana (moins de messages)
      nextStep();
    }, 250);

  }

  function open(opts) {
    opts = opts || {};
    var old = document.querySelector(".nana-modal");
    if (old) old.remove();
    var modal = buildModal();
    document.body.appendChild(modal);
    document.documentElement.classList.add("nana-lock");
    requestAnimationFrame(function () { modal.classList.add("is-open"); });

    var chat = modal.querySelector(".nana-chat");
    var options = modal.querySelector(".nana-options");
    var bar = modal.querySelector(".nana-bar");
    var input = modal.querySelector(".nana-input");
    var send = modal.querySelector(".nana-send");
    var mic = modal.querySelector(".nana-mic");
    var api = {};

    // les messages defilent dans le corps de la fenetre
    var body = modal.querySelector(".nana-body");
    new MutationObserver(function () { body.scrollTop = body.scrollHeight; }).observe(chat, { childList: true });
    new MutationObserver(function () { body.scrollTop = body.scrollHeight; }).observe(options, { childList: true });

    function lancer(fidelite) {
      runDiagnostic({ chat: chat, options: options }, { firstMessage: opts.firstMessage ? esc(opts.firstMessage) : "", firstRaw: opts.firstMessage || "", prenom: opts.prenom || "", fidelite: fidelite }, api);
    }
    // Cliente connectee : ses visites au salon (section gr-nana-cliente, calculee par Shopify
    // avec sa session). Si ca ne repond pas vite, Nana demarre sans.
    if (opts.prenom && window.fetch) {
      var parti = false;
      var go = function (f) { if (!parti) { parti = true; lancer(f); } };
      setTimeout(function () { go(null); }, 1500);
      fetch("/?sections=gr-nana-cliente", { credentials: "same-origin" })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var m = String(j["gr-nana-cliente"] || "").match(/<script[^>]*data-gr-nana-cliente[^>]*>([\s\S]*?)<\/script>/);
          go(m ? JSON.parse(m[1]) : null);
        })
        .catch(function () { go(null); });
    } else {
      lancer(null);
    }

    function close() {
      modal.classList.remove("is-open");
      document.documentElement.classList.remove("nana-lock");
      setTimeout(function () { modal.remove(); }, 300);
    }
    modal.querySelector(".nana-close").addEventListener("click", close);
    function onKey(e) { if (e.key === "Escape") { document.removeEventListener("keydown", onKey); close(); } }
    document.addEventListener("keydown", onKey);

    input.addEventListener("input", function () { send.classList.toggle("is-ready", !!input.value.trim()); });

    // texte tape dans la barre du bas : sert de reponse a la question en cours
    function normalize(t) { return (t || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, ""); }
    function answer(text) {
      text = (text || "").trim();
      if (!text) return;
      if (api.onFree) {
        api.onFree(text);
        input.value = "";
        send.classList.remove("is-ready");
        return;
      }
      var field = options.querySelector(".diag-text-input");
      if (field) {
        field.value = text;
        var ok = options.querySelector(".diag-btn");
        if (ok) ok.click();
      } else {
        var t = normalize(text);
        var best = null, bestScore = 0;
        var vides = /^(est|les|des|une|pas|que|qui|mes|vos|mon|ma|sont|plus|tres|pour|avec|dans|c'est)$/;
        options.querySelectorAll(".diag-btn").forEach(function (b) {
          var words = normalize(b.textContent).split(/[^a-z0-9]+/).filter(function (w) { return w.length > 2 && !vides.test(w); });
          var score = words.filter(function (w) { return t.indexOf(w) !== -1; }).length;
          if (score > bestScore) { best = b; bestScore = score; }
        });
        var hs0 = api.horsSujet && api.horsSujet(text);
        if (hs0 && bestScore < 2) best = null;
        if (best) {
          best.click();
        } else {
          var u = document.createElement("div");
          u.className = "diag-message diag-user"; u.textContent = text; chat.appendChild(u);
          var r = document.createElement("div");
          r.className = "diag-message diag-bot";
          var hs = api.horsSujet && api.horsSujet(text);
          r.innerHTML = hs
            ? hs + (options.querySelector(".diag-btn") ? "<br>Reprenons : touchez une des réponses juste au-dessus 🌸" : "")
            : options.querySelector(".diag-btn")
            ? "Je n'ai pas bien compris 🩷 Touchez une des réponses proposées juste au-dessus."
            : "Merci 🩷";
          chat.appendChild(r);
        }
      }
      input.value = "";
      send.classList.remove("is-ready");
    }
    bar.addEventListener("submit", function (e) { e.preventDefault(); answer(input.value); });

    var Speech = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!Speech) {
      mic.style.display = "none";
    } else {
      var rec = null;
      mic.addEventListener("click", function () {
        if (rec) { rec.stop(); return; }
        rec = new Speech();
        rec.lang = "fr-FR";
        rec.interimResults = true;
        rec.onresult = function (e) {
          var said = Array.prototype.map.call(e.results, function (r) { return r[0].transcript; }).join(" ");
          input.value = said;
          send.classList.add("is-ready");
          if (e.results[e.results.length - 1].isFinal) { answer(said); }
        };
        rec.onend = rec.onerror = function () { mic.classList.remove("is-listening"); rec = null; };
        mic.classList.add("is-listening");
        rec.start();
      });
    }
  }

  window.GrenadineNana = { open: open };
})();
